import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import dustbin from "../assets/dustbin.png";
import {
  cancelOrderAsync,
  fetchOrdersByUserAsync,
  selectOrderLoaded,
  selectOrderStatus,
  selectOrders,
} from "../features/order/orderSlice";
import { selectLogginUser } from "../features/auth/authSlice";
import { Navigate } from "react-router-dom";
import { selectUserInfo, selectUserStatus } from "../features/user/userSlice";
import Swal from "sweetalert2";
const UserOrders = () => {
  const dispatch = useDispatch();
  const user = useSelector(selectLogginUser);
  const orders = useSelector(selectOrders);
  const orderStatus = useSelector(selectOrderStatus);
  const userStatus = useSelector(selectUserStatus);
  const orderLoaded = useSelector(selectOrderLoaded);
  const handleRemove = (order) => {
    Swal.fire({
      title: `Are you sure you want to cancel`,
      text: `order number #${order.id}?`,
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "red",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, cancel it!",
      cancelButtonText: "No,don't cancel it",
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(cancelOrderAsync(order.id));
      }
    });
  };
  return (
    <div>
      {!user && <Navigate to="/login" replace="true"></Navigate>}{" "}
      {!orders.length && orderLoaded && (
        <Navigate to="/home" replace="true"></Navigate>
      )}
      <div className="mx-auto  max-w-2xl px-4 py-6 sm:px-6 sm:py-4 lg:max-w-7xl lg:px-8">
        {orders &&
          orderLoaded &&
          orders.map((order) => (
            <div key={order.id}>
              <div>
                <div className="mx-auto mt-12 bg-white max-w-7xl px-4 sm:px-6 lg:px-8">
                  <div className="border-t border-gray-200 px-4 py-6 sm:px-6 text-left">
                    <div className="flex items-center justify-between">
                      <h1 className="text-sm md:text-2xl  my-5 font-bold tracking-tight text-gray-900">
                        Order # {order.id}
                      </h1>
                      <img
                        src={dustbin}
                        className="w-6 h-6"
                        alt=""
                        onClick={() => handleRemove(order)}
                      />
                    </div>
                    <h3 className="text-xl my-5 font-bold tracking-tight text-red-900">
                      Order Status : {order.status}
                    </h3>
                    <div className="flow-root">
                      <ul
                        role="list"
                        className="-my-6 divide-y divide-gray-200"
                      >
                        {order.items.map((item) => (
                          <li key={item.id} className="flex py-6">
                            <div className="h-24 w-24 flex-shrink-0 overflow-hidden rounded-md border border-gray-200">
                              <img
                                src={item.product.images[0]}
                                alt={item.product.title}
                                className="h-full w-full object-cover object-center"
                              />
                            </div>

                            <div className="ml-4 flex flex-1 flex-col">
                              <div>
                                <div className="flex justify-between text-base font-medium text-gray-900">
                                  <h3>
                                    <a href={item.product.href}>
                                      {item.product.title}
                                    </a>
                                  </h3>
                                  <p className="ml-4">
                                    ${item.product.discountPrice}
                                  </p>
                                </div>
                                <p className="mt-1 text-sm text-gray-500 text-left">
                                  {item.product.gender
                                    ? item.product.gender
                                    : item.product.kids}
                                  's {item.product.category}
                                </p>
                              </div>
                              <div className="flex flex-1 items-end justify-between text-sm">
                                <div className="text-gray-500">
                                  <label
                                    htmlFor="quantity"
                                    className="inline mr-5 text-sm font-medium leading-6 text-gray-900"
                                  >
                                    Qty :{item.quantity}
                                  </label>
                                </div>

                                <div className="flex"></div>
                              </div>
                            </div>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>

                  <div className="border-t border-gray-200 px-4 py-6 sm:px-6">
                    <div className="flex justify-between my-2 text-base font-medium text-gray-900">
                      <p>Subtotal</p>
                      <p>$ {order.totalAmount}</p>
                    </div>
                    <div className="flex justify-between my-2 text-base font-medium text-gray-900">
                      <p>Total Items in Cart</p>
                      <p>{order.totalItems} items</p>
                    </div>
                    <p className="mt-0.5 text-sm text-gray-500">
                      Shipping Address :
                    </p>
                    <div className="flex justify-between gap-x-6 px-5 py-5 border-solid border-2 border-gray-200">
                      <div className="flex gap-x-4">
                        <div className="min-w-0 flex-auto">
                          <p className="text-sm font-semibold leading-6 text-gray-900">
                            {order.selectedAddress[0].name}
                          </p>
                          <p className="mt-1 truncate text-xs leading-5 text-gray-500">
                            {order.selectedAddress[0].street}
                          </p>
                          <p className="mt-1 truncate text-xs leading-5 text-gray-500">
                            {order.selectedAddress[0].pinCode}
                          </p>
                        </div>
                      </div>
                      <div className="hidden sm:flex sm:flex-col sm:items-end">
                        <p className="text-sm leading-6 text-gray-900">
                          Phone: {order.selectedAddress[0].phoneNumber}
                        </p>
                        <p className="text-sm leading-6 text-gray-500">
                          {order.selectedAddress[0].city}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        {userStatus === "loading" && orderStatus === "loading" ? (
          <div className="w-full my-4 flex justify-center">
            <div
              className="inline-block  h-8 w-8 animate-spin rounded-full  border-4 border-solid border-current border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]"
              role="status"
            >
              <span className="!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]">
                Loading...
              </span>
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default UserOrders;
